import { render } from "./PhoneMockup.vue?vue&type=template&id=18d4bf8f&scoped=true&ts=true"
import script from "./PhoneMockup.vue?vue&type=script&lang=ts"
export * from "./PhoneMockup.vue?vue&type=script&lang=ts"

import "./PhoneMockup.vue?vue&type=style&index=0&id=18d4bf8f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18d4bf8f"]])

export default __exports__